<template>
    <div>
        
      <b-button variant="gradient-info" @click="sendFile"> Eviar </b-button>
      <b-form-file
        ref="files"
        id="files"
        accept="image/*"
        name="Arquivo"
      />

    </div>
</template>
  
  <script>
    import { BFormFile,BButton } from 'bootstrap-vue'
  export default {
    name: 'App',
    components: {
        BButton,
        BFormFile,
     },
    methods: {
      async sendFile() {
        let dataForm = new FormData();
        for (let file of this.$refs.files.files) {
          dataForm.append(`file`, file);
        }

        let res = await fetch(`http://localhost:3000/upload`, {
          method: 'POST',
          body: dataForm,
        });
        
        let data = await res.json();
        console.log(data);
      },
    },
  };
  </script>


<!-- <template>
    <div>
        <PhotoCapture 
        
        :styling="styling" 
        v-model="imageBase64"
        captureBtnContent="Tirar Foto"
        cancelBtnContent="Cancelar"
        doneBtnContent="Usar imagem"
        @input="handleDone"/>
    </div>
</template>

<script>
import {PhotoCapture} from 'vue-media-recorder'

export default {
    data(){
        return {
            imageBase64: '',
            styling:{
                        'max-width':'20%'
                    }
        }
    },
    components:{
        PhotoCapture,
    },
  
    methods:{
        handleDone(base64){
            console.log(base64)
        }
    }
}
</script> -->